import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Link } from "react-spark";
import store from "./googleAddressVerifyStore";
import * as actions from "./actions/google-address-verify";
import * as selectors from "./state-selectors/google-address-verify";
import GoogleAddressInput from "./components/google-address-input/GoogleAddressInput";
import GoogleAddressResults from "./components/google-address-results/GoogleAddressResults";
import GoogleAddressAttributions from "./components/google-address-attributions/GoogleAddressAttributions";

import { wrapComponentWithProvider } from "../../containers/root-view/RootView";

export class GoogleAddressVerify extends Component {
  handleToggleClick(event) {
    event.preventDefault();
    this.props.setShouldDisplayComponent(false);
  }

  componentWillReceiveProps(nextProps) {
    const { onChange, selectedAddress } = this.props;
    const addressChanged =
      JSON.stringify(selectedAddress) !==
      JSON.stringify(nextProps.selectedAddress);
    if (typeof onChange === "function" && addressChanged) {
      onChange(nextProps.selectedAddress);
    }
  }

  render() {
    const {
      fetchingAddressDetails,
      fetchingAddressPredictions,
      addressInput,
      addressPredictions,
      selectedAddress,
      pendingAddressPredictionsFetch,
      helper,
      hasSeenError,
      hideLabel,
      className,
      errorMessage,
      logoSrc,
      context,
      placeholder
    } = this.props;
    const addressInvalid = this.isAddressInvalid();
    const addressInputEmpty = addressInput === "";
    const addressPredictionsEmpty =
      !addressPredictions || addressPredictions.length === 0;
    const isAddressSelected = !_.isEmpty(selectedAddress);
    const isLoading =
      fetchingAddressDetails ||
      pendingAddressPredictionsFetch ||
      fetchingAddressPredictions;
    const addressNotFound =
      !addressInvalid &&
      addressPredictionsEmpty &&
      !addressInputEmpty &&
      !pendingAddressPredictionsFetch &&
      !fetchingAddressPredictions &&
      !fetchingAddressDetails &&
      !isAddressSelected;
    const inputInsufficient =
      !addressInvalid &&
      !addressInputEmpty &&
      !pendingAddressPredictionsFetch &&
      !fetchingAddressPredictions &&
      !fetchingAddressDetails &&
      !isAddressSelected
        ? "true"
        : "false";
    const rootClasses = `google-address-root${
      addressInvalid || addressNotFound ? " invalid" : ""
    }${isLoading ? " loading" : ""}`;
    const labelClasses = ``;
    const shouldDisplayError =
      (addressInvalid || addressNotFound || hasSeenError) &&
      addressPredictionsEmpty;
    const errorText = addressInvalid
      ? "Complete street address required. "
      : addressNotFound
      ? "Address not found. "
      : "";

    return (
      <div className={rootClasses}>
        <GoogleAddressInput
          className={className}
          error={errorMessage}
          inputInsufficient={inputInsufficient}
          helper={helper}
          placeholder={placeholder}
          context={context}
        />
        {shouldDisplayError ? (
          <p className="subtext address-fallback">
            {errorText}
            <Link onClick={e => this.handleToggleClick(e)}>
              Can't find your address?
            </Link>
          </p>
        ) : null}
        <GoogleAddressResults logoSrc={logoSrc}/>
        <GoogleAddressAttributions />
      </div>
    );
  }

  isAddressInvalid() {
    const { selectedAddress, forceAddressValidation } = this.props;
    return (
      (!_.isEmpty(selectedAddress) || forceAddressValidation) &&
      !selectedAddress.isValid
    );
  }
}

GoogleAddressVerify.propTypes = {
  setShouldDisplayComponent: PropTypes.func,
  addressInput: PropTypes.string,
  addressPredictions: PropTypes.array,
  forceAddressValidation: PropTypes.bool,
  fetchingAddressDetails: PropTypes.bool,
  fetchingAddressPredictions: PropTypes.bool,
  pendingAddressPredictionsFetch: PropTypes.bool,
  shouldDisplayComponent: PropTypes.bool,
  hasSeenError: PropTypes.bool,
  selectedAddress: PropTypes.shape({
    streetAddress: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    formattedAddress: PropTypes.string,
    htmlAttributions: PropTypes.array,
    hasValidCity: PropTypes.bool,
    hasValidStreetAddress: PropTypes.bool,
    isValid: PropTypes.bool
  })
};

const mapStateToProps = state => ({
  addressInput: selectors.getAddressInput(state),
  addressPredictions: selectors.getAddressPredictions(state),
  selectedAddress: selectors.getSelectedAddress(state),
  forceAddressValidation: selectors.getForceAddressValidation(state),
  fetchingAddressDetails: selectors.getFetchingAddressDetails(state),
  fetchingAddressPredictions: selectors.getFetchingAddressPredictions(state),
  pendingAddressPredictionsFetch: selectors.getPendingAddressPredictionsFetch(
    state
  ),
  shouldDisplayComponent: selectors.getShouldDisplayComponent(state),
  hasSeenError: selectors.getHasSeenError(state)
});

const mapDispatchToProps = dispatch => ({
  setShouldDisplayComponent: shouldDisplay =>
    dispatch(actions.setShouldDisplayComponent(shouldDisplay))
});

export const ConnectedGoogleAddressVerify = connect(
  mapStateToProps,
  mapDispatchToProps
)(GoogleAddressVerify);
export default wrapComponentWithProvider(ConnectedGoogleAddressVerify, store);
